module.exports = {"phase":{"B1":["Basement","0","1","2","3","4","5","6","7","8","9","10","11","Roof"],"B2":["Basement","0","1","2","3","4","5","6","7","8","9","10","11","12","Roof"],"B5":["Basement","0","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","Roof"],"Site Wide":["Other (specify below)"],"Completed Area (Estates)":["Other (specify below)"]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/silkStream.json
// module id = 127
// module chunks = 0